import React from 'react';
import {
  CalendarIcon, CurrencyDollarIcon, VideoCameraIcon, DocumentTextIcon,
} from '@heroicons/react/outline';
import Button, {ButtonSizes, ButtonTypes} from './ButtonNew';

export default function ResumeTab({coach, trackerEvent}) {
  const hasAsync = coach.Services.includes('Resume Review');
  const hasSync = coach.Services.includes('Resume Review Call');
  return (
    <div className="lg:flex flex-col px-6 py-5 pb-4 w-full shadow-sm border border-gray-200 rounded-lg bg-white">
      <span className="text-lg font-semibold">
        Get your resume reviewed
      </span>
      <div className="mt-2 mb-4 flex flex-col text-base font-medium text-gray-500 justify-center space-y-1">
        <span className="text-gray-700">{`${coach['First name']} is on Exponent's expert resume review team`}</span>
        {hasAsync && (
        <>
          <span className="flex items-center justify-start">
            <DocumentTextIcon className="w-6 mr-2 text-indigo-600" />
            Get written feedback
          </span>
          <span className="flex items-center justify-start">
            <CalendarIcon className="w-6 mr-2 text-indigo-600" />
            5 day turnaround
          </span>
        </>
        )}
        {hasSync && (
        <span className="flex items-center justify-start">
          <VideoCameraIcon className="w-6 mr-2 text-indigo-600" />
          1-on-1 session available
        </span>
        )}
        <span className="flex items-center justify-start">
          <CurrencyDollarIcon className="w-6 mr-2 text-indigo-600" />
          Money-back guarantee
        </span>
      </div>
      <div className="flex flex-col">
        <Button
          size={ButtonSizes.LARGE}
          className="mb-2 whitespace-nowrap"
          href={hasAsync ? `/resume/upload?coach=${coach.slug}&name=${coach.Name}` : `/resume/upload?from=call&coach=${coach.slug}&name=${coach.Name}`}
          onClick={() => trackerEvent?.()}
        >
          Upload Resume
        </Button>
        <Button
          size={ButtonSizes.LARGE}
          buttonType={ButtonTypes.TERTIARY}
          href="/resume"
        >
          Learn more
        </Button>
      </div>
    </div>
  );
}
